import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_secretIdAdapter1o4zeaz9dqdiz as get_secretIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { DeleteSecretInput42tzeavgre6q as DeleteSecretInput } from '../DeleteSecretInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeleteSecretInput_InputAdapterClass;
function DeleteSecretInput_InputAdapter() {
  if (DeleteSecretInput_InputAdapterClass === VOID) {
    class $ {
      s3x(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      w6s(writer, customScalarAdapters, value) {
        writer.n4a('partyId');
        get_partyIdAdapter().t3x(writer, customScalarAdapters, value.o6p_1);
        writer.n4a('secretId');
        get_secretIdAdapter().t3x(writer, customScalarAdapters, value.p6p_1);
      }
      t3x(writer, customScalarAdapters, value) {
        return this.w6s(writer, customScalarAdapters, value instanceof DeleteSecretInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DeleteSecretInput_InputAdapter', VOID, VOID, [Adapter()]);
    DeleteSecretInput_InputAdapterClass = $;
  }
  return DeleteSecretInput_InputAdapterClass;
}
var DeleteSecretInput_InputAdapter_instance;
function DeleteSecretInput_InputAdapter_getInstance() {
  return DeleteSecretInput_InputAdapter_instance;
}
//region block: init
DeleteSecretInput_InputAdapter_instance = new (DeleteSecretInput_InputAdapter())();
//endregion
//region block: exports
export {
  DeleteSecretInput_InputAdapter_instance as DeleteSecretInput_InputAdapter_instance3skjgu5eazxig,
};
//endregion

//# sourceMappingURL=DeleteSecretInput_InputAdapter.mjs.map
